<template>
  <div class="col-6 col-lg-3">
    <div class="ibox kpi-card">
      <div class="ibox-body text-center" :class="cardClass">
        <div class="kpi-icon">
          <i :class="icon"
             class="fa-3x"
             data-toggle="tooltip"
             data-placement="top"
             :title="tooltip"></i>
        </div>
        <h3 class="kpi-value">{{ formatValue(value) }}</h3>
        <p class="kpi-label">{{ label }}</p>
        <small class="kpi-subtitle">{{ subtitle }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KPICard',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    },
    cardClass: {
      type: String,
      default: 'kpi-card-primary'
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatValue(value) {
      if (typeof value === 'number') {
        if (value >= 1000) {
          return value.toLocaleString()
        }
        if (value % 1 !== 0) {
          return value.toFixed(1)
        }
        return value.toString()
      }
      return value
    }
  },
  mounted() {
    // Inicializar tooltips de Bootstrap si están disponibles
    if (typeof $ !== 'undefined' && $.fn.tooltip) {
      $('[data-toggle="tooltip"]').tooltip()
    }
  }
}
</script>

<style scoped>
.kpi-card {
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 15px;
  height: 150px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.kpi-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.ibox-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 14px 10px;
}

.kpi-icon {
  margin-bottom: 8px;
  flex-shrink: 0;
}

.kpi-icon i {
  font-size: 1.6rem !important;
}

.kpi-value {
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 6px;
  line-height: 1.1;
  flex-shrink: 0;
}

.kpi-label {
  font-size: 0.8rem;
  margin-bottom: 4px;
  font-weight: 700;
  line-height: 1.2;
  flex-shrink: 0;
  letter-spacing: 0.3px;
}

.kpi-subtitle {
  font-size: 0.75rem;
  opacity: 0.95;
  line-height: 1.2;
  flex-shrink: 0;
  font-weight: 500;
}

/* Clases de tarjetas KPI con mejor contraste */
.kpi-card-primary {
  background: linear-gradient(135deg, #1a4a6b 0%, #2c5aa0 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.kpi-card-danger {
  background: linear-gradient(135deg, #c82333 0%, #dc3545 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.kpi-card-success {
  background: linear-gradient(135deg, #1e7e34 0%, #28a745 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.kpi-card-purple {
  background: linear-gradient(135deg, #5a2d82 0%, #6f42c1 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.kpi-card-warning {
  background: linear-gradient(135deg, #e0a800 0%, #ffc107 100%);
  color: #212529;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.kpi-card-info {
  background: linear-gradient(135deg, #138496 0%, #17a2b8 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.kpi-card-dark-purple {
  background: linear-gradient(135deg, #343a40 0%, #495057 100%);
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Responsive adjustments */
@media (min-width: 992px) {
  /* Pantallas LG y superiores - 6 columnas */
  .kpi-card {
    height: 145px;
  }

  .kpi-value {
    font-size: 1.5rem;
  }

  .kpi-label {
    font-size: 0.78rem;
  }

  .kpi-subtitle {
    font-size: 0.72rem;
  }

  .kpi-icon i {
    font-size: 1.5rem !important;
  }

  .ibox-body {
    padding: 12px 8px;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  /* Pantallas MD - 4 columnas */
  .kpi-card {
    height: 155px;
  }

  .kpi-value {
    font-size: 1.7rem;
  }

  .kpi-label {
    font-size: 0.85rem;
  }

  .kpi-subtitle {
    font-size: 0.78rem;
  }

  .kpi-icon i {
    font-size: 1.7rem !important;
  }
}

@media (max-width: 767px) {
  .kpi-card {
    height: 160px;
  }

  .kpi-value {
    font-size: 1.7rem;
  }

  .kpi-label {
    font-size: 0.85rem;
  }

  .kpi-subtitle {
    font-size: 0.78rem;
  }

  .kpi-icon i {
    font-size: 1.8rem !important;
  }
}

@media (max-width: 576px) {
  .kpi-card {
    height: 150px;
  }

  .kpi-value {
    font-size: 1.6rem;
  }

  .ibox-body {
    padding: 14px 10px;
  }

  .kpi-icon i {
    font-size: 1.6rem !important;
  }
}
</style>
